import React, { useCallback, useEffect, useState } from "react";
import Mainbackground from "../components/Mainbackground";
import "../Css/Portfolio.css";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
function Portfolio() {
  const path = "portfolio";
  const { lang } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const [portfolio, setPortfolio] = useState([]);
  const [typeofportfolio, setTypeOfPortfolio] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };
  const getPortfolio = useCallback(async () => {
    try {
      const [PortfolioRes, typeofportfolioRes] = await Promise.all([
        axios.get(`${API_URL}/portfolio/${lang}`),
        axios.get(`${API_URL}/typeofportfolio/${lang}`),
      ]);
      setPortfolio(PortfolioRes.data);
      setTypeOfPortfolio(typeofportfolioRes.data);
    } catch (error) {
      console.error("Error:", error);
    }
  }, [lang]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getPortfolio();
  }, [getPortfolio]);
  // Filter portfolios based on selected type
  const filteredPortfolio = portfolio.filter((portfolioData) => {
    if (activeFilter === "All") return true; // Show all if "All" is selected

    const portfolioTypes = portfolioData.types.split(","); // Assuming types are comma-separated
    return portfolioTypes.includes(activeFilter); 
  });
  return (
    <>
      <Mainbackground path={path} />

      <section className="margin_section">
        <div className="container">
          <div className="d-flex flex-wrap justify-content-center align-items-center mb-3">
            <button
              type="button"
              className={`btn btn-light ${
                activeFilter === "All"
                  ? "hover_filter_btn_portfolio"
                  : "filter_portfolio"
              }`}
              onClick={() => handleFilterClick("All")}
            >
              {lang === 'ar' ? 'الكل' :'All'}
            </button>
            {typeofportfolio.map((types) => (
              <div key={types.id}>
                <button
                  type="button"
                  className={`btn btn-light ${
                    activeFilter === `${types.type}`
                      ? "hover_filter_btn_portfolio"
                      : "filter_portfolio"
                  }`}
                  onClick={() => handleFilterClick(types.type)}
                >
                  {types.type}
                </button>
              </div>
            ))}
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            {filteredPortfolio.length > 0 ? (
              filteredPortfolio.map((portfolioData) => (
                <div
                  className="col-lg-4 col-md-12 col-sm-12 mb-4"
                  key={portfolioData.id}
                >
                  <Link
                    to={`/${lang}/portfoliodetails/${portfolioData.id}`}
                    key={portfolioData.id}
                  >
                    <div className="card text-bg-dark card_portfolio">
                      <img
                        src={`${API_URL}/${portfolioData.image}`}
                        className="card-img img_portfolio"
                        alt="website img"
                        title="website-img"
                        loading="lazy"
                      />
                      <div className="card-img-overlay card_cont_portfolio">
                        <h5 className="card-title card_title_portfolio">
                          {portfolioData.title}
                        </h5>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="col-lg-12 col-md-12 col-sm-12">
                <p className="text-center text_portfolio_empty">
                  {lang === 'ar' ? 'لا يوجد مشاريع':  'No Projects found.'}
                </p>
              </div>
            )}
            {/* <div className="col-lg-4 col-md-12 col-sm-12">
              <div className="card text-bg-dark card_portfolio">
                <img
                  src={portfolioimg}
                  className="card-img img_portfolio"
                  alt="website img"
                  title="website-img"
                />
                <div className="card-img-overlay card_cont_portfolio">
                  <h5 className="card-title card_title_portfolio">Ba9ma</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12">
              <div className="card text-bg-dark card_portfolio">
                <img
                  src={portfolioimg}
                  className="card-img img_portfolio"
                  alt="website img"
                  title="website-img"
                />
                <div className="card-img-overlay card_cont_portfolio">
                  <h5 className="card-title card_title_portfolio">Ba9ma</h5>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default Portfolio;
